<template>                    
    <form-helper>
        <div slot="form-header">
            
            <h2 class="grey--text text--darken-2">Anschriftsdaten</h2>                                                
            
        </div>
        
        <div slot="form-fields">
            <v-layout row wrap>
            <v-flex xs8>
                <v-text-field
                  name="strasse"
                  label="Strasse"
                  :error="errors.has('strasse')" 
                  id="Strasse"
                  v-model="ad.strasse"
                   v-validate="'required|min:3'"
                    ></v-text-field>
                    <small class="small red--text" v-show="errors.has('strasse')">{{ errors.first('strasse') }}</small>                 
            </v-flex>
            <v-flex xs8>
                <v-flex xs4>
                    <v-text-field
                      name="plz"
                      label="PLZ"
                      :error="errors.has('plz')" 
                      id="plz"
                      v-model="ad.plz" 
                      v-validate="'required|min:3'"
                    ></v-text-field>
                    <small class="small red--text" v-show="errors.has('plz')">{{ errors.first('plz') }}</small> 
                </v-flex>
                
                <v-flex xs8>
                    <v-text-field
                      name="ort"
                      label="Ort"
                      :error="errors.has('ort')"  
                      id="ort"
                      v-model="ad.ort"
                      v-validate="'required|min:3'"
                    ></v-text-field>
                    <small class="small red--text" v-show="errors.has('ort')">{{ errors.first('ort') }}</small> 
                </v-flex>
            </v-flex>
            <v-flex xs6>
                <v-text-field
                  name="land"
                  label="Land"
                  id="land"
                  v-model="ad.land"
                ></v-text-field>
            </v-flex>
             
                                     
            </v-layout>   
        </div>
        
        <div slot="form-commands" >

            <v-btn icon v-on:click="submitted">
                <v-icon x-large class="green--text">done</v-icon>
            </v-btn>                        


            <router-link to="/firmen" exact>
                <v-btn icon>
                    <v-icon x-large class="red--text">close</v-icon>
                </v-btn>
            </router-link>

        </div>
    </form-helper>



</template>

<script>
import formHelper from '../formHelper.vue'

export default {
    inject:['$validator'],
    components: {
        'form-helper': formHelper
    },
    data() {
        return {
            id: this.$route.params.id,            
        };
    },
    computed: {
        ad: function() {
            return this.$store.getters.adresse
        },
        loading: function() {
            return this.$store.getters.loading
        }
        
    },
              
    methods: {
        submitted: function() {
            this.$store.commit('setMessagebar', false)
            this.$validator.validateAll().then((result) =>{
               if(!result) {
                   this.$store.commit('setMessagebar',true)
                   return
                }                    
                this.$emit('submitted', this.ad)
            })
        },
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// editAdressen_1.vue?52aac1f6